import type { IconData } from '@stacksjs/iconify-core'

export const tagAltFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M41.368 1.702c-6.806-.423-13.042-.082-15.884.129c-1.34.1-2.616.582-3.684 1.423c-3.035 2.392-10.896 8.994-18.831 19.018c-1.726 2.18-1.976 5.215-.184 7.55c1.365 1.778 3.576 4.424 7.12 8.204c4.125 4.4 7.034 6.747 8.922 7.998c2.073 1.374 4.5.896 6.219-.404c10.545-7.98 17.383-16.341 19.77-19.47a6.7 6.7 0 0 0 1.348-3.574c.21-2.813.56-9.09.133-15.945a5.26 5.26 0 0 0-4.93-4.93Z\"/><path fill=\"#2859c5\" d=\"M33.5 11a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tagAltFlat
